export enum SvgIconName {
  StudioIcon = 'studio-icon',
  StudioIconHover = 'studio-icon-hover',

  RedDotIcon = 'red-dot-icon',
  MacCloseIcon = 'mac-close-icon',
  MacMinimizeIcon = 'mac-minimize-icon',
  MacFullScreenIcon = 'mac-full-screen-icon',
  MacCancelFullScreenIcon = 'mac-cancel-full-screen-icon',
  BackIcon = 'back-icon',
  BackIconBlueHover = 'back-icon-blue-hover',

  OrgIcon = 'org-icon',
  OrgIconHover = 'org-icon-hover',

  SettingIcon = 'setting-icon',
  SettingIconHover = 'setting-icon-hover',

  BillingIcon = 'billing-icon',
  BillingIconHover = 'billing-icon-hover',

  AuditHubIcon = 'audit-icon',
  AuditHubIconHover = 'audit-icon-hover',

  GameCardAddIcon = 'game-card-add-icon',

  InviteAddIcon = 'invite-add-icon',

  StudioNameEdit = 'studio-name-edit',
  Copy = 'copy',
  StudioDelete = 'studio-delete',

  'player-outline' = 'player-outline',
  'service-battle' = 'service-battle',
  'matchmaking' = 'matchmaking',
  'hosting-outline' = 'hosting-outline',
  'custom-data' = 'custom-data',
  'auto-task' = 'auto-task',
  'leader-boards' = 'leader-boards',
  'text-chat' = 'text-chat',
  'add-ons' = 'add-ons',
  'dynamic-update' = 'dynamic-update',
  'grafana' = 'grafana',
  'health-monitor' = 'health-monitor',
  'privacy-access' = 'privacy-access',
  'audithub' = 'audithub',
  'notifications' = 'notifications',
  'microservice' = 'microservice',
  'launch-update' = 'launch-update',
  'game-items' = 'game-items',
  'store' = 'store',
  'mail' = 'mail',
  'commands' = 'commands',
  'gadgets' = 'gadgets',
  'remote-config' = 'remote-config',
  'friends' = 'friends',
}
